import fotos_borito from './fotos_borito.json';
import init from './../../cover_template.json';
import bor_borito from './bor_borito.json';
import calligrafia from './calligrafia.json';
import finessa from './finessa.json';
import la_fontana_di_stile from './la_fontana_di_stile.json';
import wedding_sensation from './wedding_sensation.json';

export default {
  fotos_borito,
  init,
  bor_borito,
  calligrafia,
  finessa,
  la_fontana_di_stile,
  wedding_sensation,
};



// WEBPACK FOOTER //
// ./src/config/templates/covers/consumer/square/index.jsx